module.exports = __webpack_public_path__ + "static/media/logo.2c40eb2b.png";